import { sleep } from "../../../app/util/sleep"
import { StudentHelperAssignmentPreparationStatus } from "../models/StudentHelperAssignmentPreparationStatus"

export class StudentHelperPoller {
  constructor(private readonly pollIntervalMs = 3000) {}

  async poll<T extends StudentHelperAssignmentPreparationStatus>(
    fn: () => Promise<T>,
  ): Promise<T> {
    const res = await fn()

    switch (res.status) {
      case "inactive":
        return res
      case "processing":
        await sleep(this.pollIntervalMs)
        return this.poll(fn)
      case "completed":
        return res
      default:
        throw new Error(`Unexpected status: ${res.status}`)
    }
  }
}
